import type { ConductWebEnvironment } from './environment.type';

export const environment: ConductWebEnvironment = {
  production: false,
  conductApiBaseUrl: 'https://conduct-api-staging.schoolbell-e.com',
  requireLogin: false,
  // schoolbell-e-web staging 커스텀 도메인(production `sbe.schoolbell-e.com` 의 staging 대응) — Firebase 기본 도메인(`*.web.app`)이 아니다.
  schoolbellEWebUrl: 'https://sbe-staging.schoolbell-e.com',
  forgetSchoolOnSignOut: true,
};
